import React, { lazy, } from "react";
import { ProtectedLayout, } from './../../components/layouts';
import { FormattedMessage, } from "react-intl";
import { useNavigate, useParams, } from 'react-router';
import { EnvelopeSimple, Tag, ChartLineUp, UserGear, PersonArmsSpread, } from "@phosphor-icons/react";
import { Row, Col, Tabs, } from 'antd';
import PageHeader from '../../components/helpers/page.header'; const SettingsEmailView = lazy(() => import('./views/settings.email.view'/* webpackChunkName: "SettingsEmailView" */));

const FinanceSettingsPageView = lazy(() => import('./views/finance/settings.finance.index'/* webpackChunkName: "FinanceSettingsPageView" */));
const PlansPricesView = lazy(() => import('./views/settings.plans.pricing.view'/* webpackChunkName: "PlansPricesView" */));
const SettingsCustomerIndex = lazy(() => import('./views/customer/settings.customer.index'/* webpackChunkName: "SettingsCustomerIndex" */));
const UserPermissionsView = lazy(() => import('./views/user.permissions/user.permissions.index'/* webpackChunkName: "UserPermissionsView" */));

const SettingsIndexPage = ({
    ...props
}) => {

    const { tab } = useParams();
    const history = useNavigate();

    // Get current user details
    const localdata = sessionStorage.getItem('authentication');
    const idToken = JSON.parse(localdata);
    const { vendor_id, } = idToken || {};
    const admin_plans = {
        label: <><Tag size={16} weight="light" /> <FormattedMessage id="system-settings-plans" /></>,
        key: "settings-plans",
        children: <PlansPricesView history={history} customerID="me" {...props} />
    };

    const tabItems = [
        {
            label: <><ChartLineUp size={16} weight="light" /> <FormattedMessage id="finance-settings" /></>,
            key: "finance-settings",
            destroyOnHidden: true,
            children: <FinanceSettingsPageView history={history} customerID="me" {...props} />
        },
        {
            label: <><UserGear size={16} weight="light" /> <FormattedMessage id="customer-settings" /></>,
            key: "customer-settings",
            destroyOnHidden: true,
            children: <SettingsCustomerIndex history={history} customerID="me" {...props} />
        },
        {
            label: <><EnvelopeSimple size={16} weight="light" /> <FormattedMessage id="system-settings-email" /></>,
            key: "settings-email",
            destroyOnHidden: true,
            children: <SettingsEmailView history={history} {...props} />
        },
        {
            label: <><PersonArmsSpread size={16} weight="light" /> <FormattedMessage id="user-permissions" /></>,
            key: "user-permissions",
            destroyOnHidden: true,
            children: <UserPermissionsView history={history} customerID="me" {...props} />
        },
        vendor_id === "0" && { ...admin_plans },
    ];

    return (

        <ProtectedLayout {...props}>
            <Row gutter={[32, 32]}>

                {/* Page header */}
                <Col span={24}>
                    <PageHeader
                        className="site-page-header"
                        onBack={() => window.history.back()}
                        title={<FormattedMessage id="system-settings-page-header" />}
                        subTitle={<FormattedMessage id="system-settings-page-header-info" />}
                        ghost={false}
                    />
                </Col>

                {/* Tab container */}
                <Col span={24} className="">

                    {/* Tabs selections */}
                    <Tabs defaultActiveKey="detail"
                        activeKey={tab}
                        items={tabItems.filter(Boolean)}
                        onChange={e => history('/system/' + e)} />
                </Col>
            </Row>
        </ProtectedLayout>
    );
};

export default SettingsIndexPage;